import * as React from 'react';


export class ProjPage extends React.Component {
    constructor(props: any, context: any) {
        super(props, context);
        
    }
    public render() {
        return <div><section>
        <h2>Summary Image</h2>
        <img src='teaser.jpg' style={{ textAlign: 'center', width: '80%' }} />
        <h2>Abstract</h2>
        <p> Visualization of attentions has effectively helped researcher to verify alignments in machine translation models.
        However, the commonly used attention visualization compromise either the readability or the information conveyed when the documents are long or when they have imbalanced size. 
        In this work, we strive toward a more intuitive attention visualization for NLP tasks where the attentions are mapped between documents with imbalanced sizes.
        In specific, starting with reading comprehension tasks where long paragraphs and short questions are presented, we extend the flow map visualization to ensure flat learning curve for NLP users and enhance the readability of the attention-augmented documents.
        Through interaction, we enable semantic filtering to help users prioritize important tokens or meaningful matchings to provide in-depth exploration.
        Through case studies and informal user studies with researchers working on reading comprehension, we prove that the visualization can effectively help users gain initial understandings about what their models are ``paying attention to''.
        We discuss how the work can be extended to other domains, as well as be plugged into more end-to-end systems for model error analysis.</p> 
        <h2>Materials</h2>
        <a href="https://github.com/cse512-18s/attention-model-explorer/blob/master/final/CSE512_18sp_vis_poster.pdf">Poster [PDF]</a> | <a href="https://github.com/cse512-18s/attention-model-explorer/blob/master/final/CSE512_18sp_vis_report.pdf">Paper [PDF]</a> 
        <h2>Running Instruction</h2>
        <h4>Frontend</h4>
        <pre> # node -v: v8.9.0; npm -v: 5.8.0</pre> 
        <pre> # may need root</pre> 
        <p><b> npm install create-react-app</b></p> 
        <p><b> npm install</b></p> 
        <p> # to run the development set</p> 
        <p><b> npm run start</b></p> 
        <p> # to do production build and upload to the github</p> 
        <p><b> yarn build</b></p> 
        <p><b> mv build docs</b></p> 
        <h4>Backend</h4>
        <p> # make sure to download and install python3.6</p> 
        <p><b> cd ./scripts</b></p> 
        <p><b> virtualenv --no-site-packages -p python3.6 venv</b></p> 
        <p><b> source venv / bin / activate</b></p > 
        <p><b> chmod + x setup.sh</b></p > 
        <p><b> ./setup.sh</b></p> 
        </section></div>
    }
}



// WEBPACK FOOTER //
// ./src/components/ProjPage.tsx